<template>
  <y-view :loading="isLoading">
    <div class="data-show">
      <h2 class="mb-1 title">基本信息</h2>
      <hr class="hr">
      <div class="mt-1 content-item">
        <div class="item">
          订单号：{{objInfo.earningOrderVO.orderSn}}
        </div>
        <div class="item">
          收益状态：{{objInfo.earningOrderVO.statusName}}
        </div>
        <div class="item">
          贸易模式：{{objInfo.earningOrderVO.tradeTypeName}}
        </div>
        <div class="item">
          销售渠道：{{objInfo.earningOrderVO.saleChannelName}}
        </div>
      </div>
      <div class="content-item">
        <div class="item">
          分销员ID：{{objInfo.earningOrderVO.shopMemberId}}
        </div>
        <div class="item">
          分销员姓名：<insensitive v-if="objInfo.earningOrderVO.shopMemberType=='3'" :val="objInfo.earningOrderVO.shopMemberName" type="name"></insensitive><template v-else>{{objInfo.earningOrderVO.shopMemberName}}</template>
        </div>
        <div class="item">
          分销角色：{{objInfo.earningOrderVO.shopMemberTypeName}}
        </div>
        <div class="item">
          门店：{{objInfo.earningOrderVO.shopName}}
        </div>
      </div>
      <div class="content-item">
        <div class="item">
          门店性质：{{objInfo.earningOrderVO.shopTypeName}}
        </div>
        <div class="item">
          客商：{{objInfo.earningOrderVO.customerName}}
        </div>
        <div class="item">
          支付时间：{{objInfo.earningOrderVO.createTime}}
        </div>
        <div class="item"></div>
      </div>
    </div>
    <div class="data-show">
      <h2 class="mb-1 title">订单基本信息</h2>
      <hr class="hr">
      <div class="mt-2">
        <div class="k-tablebox k-tablebox--big k-tablebox--stripe k-tablebox--bordered" style="border-bottom: 0;">
          <div class="k-theadwrapper">
            <table class="k-table k-table--auto text-center">
              <!-- <colgroup>
                <col style="width: 120px;">
                <col style="width: 100px;">
                <col style="width: 150px;">
                <col style="width: 84px;">
                <col style="width: 80px;">
              </colgroup> -->
              <thead>
                <!-- <tr>
                  <th colspan="9">基本信息</th>
                  <th colspan="5">收益</th>
                </tr> -->
                <tr>
                  <th>商品名称</th>
                  <th style="width: 110px;">物料编号</th>
                  <th style="width: 110px;">总数量</th>
                  <th style="width: 110px;">平台价</th>
                  <th style="width: 110px;">门店价</th>
                  <th style="width: 110px;">微店成本价</th>
                  <th style="width: 110px;">成交价</th>
                  <th style="width: 110px;">B2C活动优惠</th>
                  <th style="width: 110px;">B2C优惠券优惠</th>
                  <!-- <th style="width: 80px;">客商</p>
                  <th style="width: 80px;">客商<p>(来自门店主账号)</p>
                  </th>
                  <th style="width: 80px;">门店主账号</th>
                  <th style="width: 80px;">推广人</th>
                  <th style="width: 80px;">员工</th> -->
                  <!-- <th style="border-bottom: 1px solid #eaecf0;">货号</th> -->
                </tr>
              </thead>
              <!-- <tfoot>
                <tr>
                  <td colspan="9"></td>
                  <td v-for="(value,key) in dataAmount.pre" :key="key">
                    {{value}}
                  </td>
                </tr>
              </tfoot> -->
              <tbody>
                <tr :key="index" v-for="(item,index) in objInfo.earningItemSaleVOList">
                  <td style="white-space:normal">
                    {{item.goodsName}}
                  </td>
                  <td :title="item.goodsCode" style="white-space:normal;word-break: break-all;">
                    {{item.goodsCode}}
                  </td>
                  <td>
                    {{item.saleQuantity}}
                  </td>
                  <td>
                    {{item.platformPrice}}
                  </td>
                  <td>
                    {{item.shopPrice}}
                  </td>
                  <td>
                    {{item.smallPrice}}
                  </td>
                  <td>
                    {{item.sellingPrice}}
                  </td>
                  <td>
                    {{item.b2cActivityDiscount}}
                  </td>
                  <td>
                    {{item.b2cCouponDiscount}}
                  </td>
                  <!-- <td>
                      {{item.earningCustomer}}
                    </td>
                    <td>
                      {{item.earningCustomerShop}}
                    </td>
                    <td>
                      {{item.earningMain}}
                    </td>
                    <td>
                      {{item.earningPromoter}}
                    </td>
                    <td>
                      {{item.earningStaff}}
                    </td> -->
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
    <div class="data-show">
      <h2 class="mb-1 title">售后基本信息</h2>
      <hr class="hr">
      <div class="mt-2">
        <ul>
          <li v-for="(item0,index0) in objInfo.earningItemRefundVOList">
            <p>售后申请单号：{{item0.refundSn}}</p>
            <div class="k-tablebox k-tablebox--big k-tablebox--stripe k-tablebox--bordered" style="border-bottom: 0;">
              <div class="k-theadwrapper">
                <table class="k-table k-table--auto text-center">
                  <thead>
                    <!-- <tr>
                      <th colspan="5">基本信息</th>
                      <th colspan="5">收益扣减</th>
                    </tr> -->
                    <tr>
                      <th>商品名称</th>
                      <th style="width: 110px;">物料编号</th>
                      <th style="width: 110px;">总数量</th>
                      <th style="width: 110px;">商品总额</th>
                      <th style="width: 110px;">退款数量</th>
                      <!-- <th style="width: 100px;">客商</p>
                      <th style="width: 80px;">客商<p>(来自门店主账号)</p>
                      </th>
                      <th style="width: 80px;">门店主账号</th>
                      <th style="width: 80px;">推广人</th>
                      <th style="width: 80px;">员工</th> -->
                      <!-- <th style="border-bottom: 1px solid #eaecf0;">货号</th> -->
                    </tr>
                  </thead>
                  <!-- <tfoot>
                    <tr>
                      <td colspan="5"></td>
                      <td v-for="(value,key) in item0.objAmount" :key="key">
                        {{value}}
                      </td>
                    </tr>
                  </tfoot> -->
                  <tbody>
                    <tr :key="index" v-for="(item,index) in item0.earningItemRefundDetailVOList">
                      <td style="white-space:normal">
                        {{item.goodsName}}
                      </td>
                      <td :title="item.goodsCode" style="white-space:normal;word-break: break-all;">
                        {{item.goodsCode}}
                      </td>
                      <td>
                        {{item.saleQuantity}}
                      </td>
                      <td>
                        {{item.totalSellingAmount}}
                      </td>
                      <td>
                        {{item.quantity}}
                      </td>
                      <!-- <td>
                          {{item.earningCustomer}}
                        </td>
                        <td>
                          {{item.earningCustomerShop}}
                        </td>
                        <td>
                          {{item.earningMain}}
                        </td>
                        <td>
                          {{item.earningPromoter}}
                        </td>
                        <td>
                          {{item.earningStaff}}
                        </td> -->
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </li>
        </ul>

      </div>
    </div>
    <!-- <div class="data-show">
      <h2 class="mb-1 title">入账收益</h2>
      <hr class="hr">
      <div class="mt-2">
        <div class="k-tablebox k-tablebox--big k-tablebox--stripe k-tablebox--bordered"
          style="border-bottom: 0;width: 800px;">
          <div class="k-theadwrapper">
            <table class="k-table k-table--auto text-center">
              <thead>
                <tr>
                  <th>流水号</th>
                  <th style="width: 100px;">类型</th>
                  <th style="width: 100px;">角色</th>
                  <th style="width:100px;">收益</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item,index) in objInfo.earningDetailVOList" :key="index">
                  <td> {{item.earningNo}}</td>
                  <td> {{item.earningTypeName}} </td>
                  <td> {{item.shopMemberTypeName}} </td>
                  <td> {{item.fee}} </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div> -->
  </y-view>
</template>
<script>
  /**
   * @name:
   * @description: 收益详情
   * @author: zhaoliubin@yuouhui.com
   * @create: 2020-10-13 13:58:21
   * @update: 2020-10-13 13:58:21
   */
  // import Mock from 'mockjs';
  export default {
    components: {},
    data() {
      return {
        isLoading: false,
        objInfo: {
          earningOrderVO: {},//收益订单信息
          earningItemSaleVOList: [],//收益-收益明细信息
          earningItemRefundVOList: [],//收益-冲销明细信息
          earningDetailVOList: [],//收益-收益/冲销信息
        },
        dataAmount: {
          pre: {
            earningCustomer: 0,
            earningCustomerShop: 0,
            earningMain: 0,
            earningPromoter: 0,
            earningStaff: 0,
          },
          afterSale: {
            earningCustomer: 0,
            earningCustomerShop: 0,
            earningMain: 0,
            earningPromoter: 0,
            earningStaff: 0,
          },
        },
        para: {
          pageCurrent: 1,
          pageSize: 15,
        },
        total: 0,
        arrDataList: [],
        id: '',
      }
    },
    computed: {},
    methods: {
      initPageData() {
        // this.arrDataList = Mock.mock({
        //   'data|5-15': [{
        //     'streamCode|10000-88888': 20,
        //     'orderCode': '@id',
        //     'afterSaleCode': '@integer(200000,500000)',
        //     'type|1': [1, 2, 3],
        //     _name: '@cname',
        //     'shopName': function () {
        //       return this._name + '的门店';
        //     },
        //     'miniShopName': function () {
        //       return this._name + '的微店';
        //     },
        //     'profitSourceType|1': ['价差收益', '门店收益'],
        //     'profitAmount|10-500': 10,
        //     'status|1': [1, 2, 3, 4]
        //   }]
        // }).data;
        // return;
        this.isLoading = true;
        this.dataAmount = this.$options.data().dataAmount;
        this.$fetch({
          api: '/nestle-finance-back-server/earning-order-back/detail',
          para: { id: this.id }
        }).then(res => {
          console.log(res);
          res.earningItemSaleVOList.forEach(item => {
            for (let key in this.dataAmount.pre) {
              this.dataAmount.pre[key] = parseFloat(this.dataAmount.pre[key]) + parseFloat((item[key] || 0));
            }
          });
          if (res.earningItemSaleVOList.length > 0) {
            for (let key in this.dataAmount.pre) {
              this.dataAmount.pre[key] = parseFloat(this.dataAmount.pre[key]) == this.dataAmount.pre[key].toFixed(2) ? this.dataAmount.pre[key] : this.dataAmount.pre[key].toFixed(2);
            }
          }

          res.earningItemRefundVOList.forEach(item0 => {
            item0.objAmount = Object.assign({}, this.$options.data().dataAmount.afterSale);
            item0.earningItemRefundDetailVOList.forEach(item => {
              for (let key in item0.objAmount) {
                item0.objAmount[key] = parseFloat(item0.objAmount[key]) + parseFloat((item[key] || 0));
              }
            })
            for (let key in item0.objAmount) {
              item0.objAmount[key] = parseFloat(item0.objAmount[key]) == item0.objAmount[key].toFixed(2) ? item0.objAmount[key] : item0.objAmount[key].toFixed(2);
            }
          });
          this.objInfo = Object.assign(this.objInfo, res);
          // this.arrDataList = res.pageList;
          this.isLoading = false;
        });
      },
    },
    created() {
      this.id = this.$route.query.id;
      this.initPageData();
    },
    beforeRouteUpdate(to, from, next) {
      this.id = to.query.id;
      this.initPageData();
    },
  }
</script>
<style lang="postcss">

</style>
